import { IconButton } from "@mui/material";
import { MoreVertRounded } from "@mui/icons-material";
import { IconZoomCode } from "@tabler/icons-react";

import { Button } from "@fragments";

import "./styles.scss";

export default function RowActions({ member, onView, onOpenMenu }) {
  function handleView(event) {
    event.stopPropagation();
    onView?.(member);
  }

  function handleMenu(event) {
    onOpenMenu?.(member, event);
  }

  return (
    <div className="members-list-row-actions" onClick={(e) => e.stopPropagation()}>
      <Button
        className="members-list-row-actions__view"
        color="overlay"
        size="small"
        startIcon={<IconZoomCode size={16} stroke={2} />}
        text="Visualizar"
        onClick={handleView}
        preventLoading
      />
      <IconButton
        className="members-list-row-actions__trigger"
        onClick={handleMenu}
        aria-label="Mais ações"
        data-member-id={member?.id}
      >
        <MoreVertRounded fontSize="small" />
      </IconButton>
    </div>
  );
}
